import { render, staticRenderFns } from "./ForceUpdatePopup.vue?vue&type=template&id=a8253fbe"
import script from "./ForceUpdatePopup.vue?vue&type=script&lang=js"
export * from "./ForceUpdatePopup.vue?vue&type=script&lang=js"
import style0 from "./ForceUpdatePopup.vue?vue&type=style&index=0&id=a8253fbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports